import Cows from "./cows.vue";

export default Cows;



// WEBPACK FOOTER //
// ./src/components/_cows/index.js